import client from "../client";

export function getResponsibilities(page?: number) {
  return client.get(`/api/v2/responsibilities${page ? `?page=${page}` : ""}`);
}
